import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AssetsFilesService {

  constructor(
    private http: HttpClient,
  ) { }

  getTermsAndConditions(): Observable<string> {
    return this.http.get('assets/termsAndConditions.txt', { responseType: 'text' });
  }

  getCookiesMessage(): Observable<string> {
    return this.http.get('assets/cookiesApprovalMessage.txt', { responseType: 'text' });
  }

}
